// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file medical_master/pricing_pending_acceptance.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PricingPendingAcceptance } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.PricingPendingAcceptanceRequest
 */
export class PricingPendingAcceptanceRequest extends Message<PricingPendingAcceptanceRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 1;
   */
  page = 0;

  /**
   * Number of items per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * Search term for filtering pending acceptance records
   *
   * @generated from field: int32 search = 3;
   */
  search = 0;

  constructor(data?: PartialMessage<PricingPendingAcceptanceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PricingPendingAcceptanceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PricingPendingAcceptanceRequest {
    return new PricingPendingAcceptanceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PricingPendingAcceptanceRequest {
    return new PricingPendingAcceptanceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PricingPendingAcceptanceRequest {
    return new PricingPendingAcceptanceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PricingPendingAcceptanceRequest | PlainMessage<PricingPendingAcceptanceRequest> | undefined, b: PricingPendingAcceptanceRequest | PlainMessage<PricingPendingAcceptanceRequest> | undefined): boolean {
    return proto3.util.equals(PricingPendingAcceptanceRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PricingPendingAcceptanceResponse
 */
export class PricingPendingAcceptanceResponse extends Message<PricingPendingAcceptanceResponse> {
  /**
   * List of pending acceptance records
   *
   * @generated from field: repeated com.neulink.pharmacy.PricingPendingAcceptance pricing_pending_acceptances = 1;
   */
  pricingPendingAcceptances: PricingPendingAcceptance[] = [];

  /**
   * Total number of pending acceptance records
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<PricingPendingAcceptanceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PricingPendingAcceptanceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pricing_pending_acceptances", kind: "message", T: PricingPendingAcceptance, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PricingPendingAcceptanceResponse {
    return new PricingPendingAcceptanceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PricingPendingAcceptanceResponse {
    return new PricingPendingAcceptanceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PricingPendingAcceptanceResponse {
    return new PricingPendingAcceptanceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PricingPendingAcceptanceResponse | PlainMessage<PricingPendingAcceptanceResponse> | undefined, b: PricingPendingAcceptanceResponse | PlainMessage<PricingPendingAcceptanceResponse> | undefined): boolean {
    return proto3.util.equals(PricingPendingAcceptanceResponse, a, b);
  }
}

